'use client';

import { c as _c } from "react/compiler-runtime";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@repo/ui/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components/ui/popover';
import { DynamicIcon, iconNames } from '@repo/ui/icons/dynamic';
import type { IconName } from '@repo/ui/icons/dynamic';
import { cn } from '@repo/ui/lib/utils';
import { useState } from 'react';
const MAX_VISIBLE_ICONS = 96;
export const DEFAULT_SAVED_VIEW_ICON: IconName = 'list-filter';
export const isIconName = (value: string): value is IconName => iconNames.some(iconName => iconName === value);
export type SavedViewIconPickerProps = {
  disabled?: boolean;
  onValueChange: (_value: IconName | null) => void;
  value: IconName | null;
  /** `icon` is a square button showing only the icon, to sit beside a name field. */
  variant?: 'field' | 'icon';
};
export const SavedViewIconPicker = t0 => {
  const $ = _c(81);
  const {
    disabled: t1,
    onValueChange,
    value,
    variant: t2
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "field" : t2;
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  let T0;
  let T1;
  let T2;
  let T3;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== disabled || $[1] !== onValueChange || $[2] !== open || $[3] !== query || $[4] !== value || $[5] !== variant) {
    const normalizedQuery = query.trim().toLowerCase();
    const matches = normalizedQuery ? iconNames.filter(name => name.includes(normalizedQuery)) : iconNames;
    const visibleIcons = matches.slice(0, MAX_VISIBLE_ICONS);
    T3 = Popover;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = nextOpen => {
        setOpen(nextOpen);
        if (!nextOpen) {
          setQuery("");
        }
      };
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    t16 = open;
    t17 = "Popover";
    t18 = "SavedViewIconPicker";
    t19 = "saved-view-icon-picker.tsx";
    const t21 = variant === "icon" ? "w-9 shrink-0 justify-center" : "w-full justify-between px-3";
    let t22;
    if ($[29] !== t21) {
      t22 = cn("flex h-9 items-center rounded-md border border-input bg-transparent text-sm shadow-xs hover:bg-muted disabled:pointer-events-none disabled:opacity-50", t21);
      $[29] = t21;
      $[30] = t22;
    } else {
      t22 = $[30];
    }
    const t23 = variant === "icon" ? value ?? "No icon" : undefined;
    const t24 = variant === "icon" && "contents";
    let t25;
    if ($[31] !== t24) {
      t25 = cn("flex items-center gap-2", t24);
      $[31] = t24;
      $[32] = t25;
    } else {
      t25 = $[32];
    }
    let t26;
    if ($[33] !== value) {
      t26 = value ? <DynamicIcon className="size-4" fallback={_temp} name={value} /> : <span className="size-4 rounded border border-dashed border-muted-foreground" />;
      $[33] = value;
      $[34] = t26;
    } else {
      t26 = $[34];
    }
    let t27;
    if ($[35] !== value || $[36] !== variant) {
      t27 = variant === "icon" ? null : <span>{value ?? "No icon"}</span>;
      $[35] = value;
      $[36] = variant;
      $[37] = t27;
    } else {
      t27 = $[37];
    }
    let t28;
    if ($[38] !== t25 || $[39] !== t26 || $[40] !== t27) {
      t28 = <span className={t25}>{t26}{t27}</span>;
      $[38] = t25;
      $[39] = t26;
      $[40] = t27;
      $[41] = t28;
    } else {
      t28 = $[41];
    }
    let t29;
    if ($[42] !== variant) {
      t29 = variant === "icon" ? null : <span className="text-xs text-muted-foreground">Change</span>;
      $[42] = variant;
      $[43] = t29;
    } else {
      t29 = $[43];
    }
    if ($[44] !== disabled || $[45] !== t22 || $[46] !== t23 || $[47] !== t28 || $[48] !== t29) {
      t20 = <PopoverTrigger aria-label="Choose icon" className={t22} disabled={disabled} title={t23} type="button" data-sentry-element="PopoverTrigger" data-sentry-source-file="saved-view-icon-picker.tsx">{t28}{t29}</PopoverTrigger>;
      $[44] = disabled;
      $[45] = t22;
      $[46] = t23;
      $[47] = t28;
      $[48] = t29;
      $[49] = t20;
    } else {
      t20 = $[49];
    }
    T2 = PopoverContent;
    t11 = "start";
    t12 = "w-[min(24rem,calc(100vw-2rem))] p-0";
    t13 = "PopoverContent";
    t14 = "saved-view-icon-picker.tsx";
    T1 = Command;
    t7 = false;
    t8 = "Command";
    t9 = "saved-view-icon-picker.tsx";
    if ($[50] !== query) {
      t10 = <CommandInput onValueChange={setQuery} placeholder="Search icons..." value={query} data-sentry-element="CommandInput" data-sentry-source-file="saved-view-icon-picker.tsx" />;
      $[50] = query;
      $[51] = t10;
    } else {
      t10 = $[51];
    }
    T0 = CommandList;
    t3 = "max-h-72";
    t4 = "CommandList";
    t5 = "saved-view-icon-picker.tsx";
    t6 = visibleIcons.length === 0 && normalizedQuery ? <CommandEmpty>No icons found.</CommandEmpty> : <><CommandGroup><CommandItem aria-label="No icon" className={cn(value === null && "bg-accent text-accent-foreground")} onSelect={() => {
          onValueChange(null);
          setOpen(false);
          setQuery("");
        }} value="no icon"><span className="size-4 rounded border border-dashed border-muted-foreground" />No icon</CommandItem></CommandGroup><CommandGroup className="p-2 [&_[cmdk-group-items]]:grid [&_[cmdk-group-items]]:grid-cols-6 [&_[cmdk-group-items]]:gap-1 sm:[&_[cmdk-group-items]]:grid-cols-8" heading={matches.length > MAX_VISIBLE_ICONS ? `Showing ${MAX_VISIBLE_ICONS} of ${matches.length}. Search to narrow the list.` : undefined}>{visibleIcons.map(iconName => <CommandItem aria-label={iconName} className={cn("flex aspect-square justify-center p-0 [&>svg:last-child]:hidden", iconName === value && "bg-accent text-accent-foreground")} key={iconName} onSelect={() => {
          onValueChange(iconName);
          setOpen(false);
          setQuery("");
        }} title={iconName} value={iconName}><DynamicIcon className="size-4" fallback={_temp2} name={iconName} /></CommandItem>)}</CommandGroup></>;
    $[0] = disabled;
    $[1] = onValueChange;
    $[2] = open;
    $[3] = query;
    $[4] = value;
    $[5] = variant;
    $[6] = T0;
    $[7] = T1;
    $[8] = T2;
    $[9] = T3;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
    $[20] = t20;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[6];
    T1 = $[7];
    T2 = $[8];
    T3 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
    t19 = $[19];
    t20 = $[20];
    t3 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t21;
  if ($[52] !== T0 || $[53] !== t3 || $[54] !== t4 || $[55] !== t5 || $[56] !== t6) {
    t21 = <T0 className={t3} data-sentry-element={t4} data-sentry-source-file={t5}>{t6}</T0>;
    $[52] = T0;
    $[53] = t3;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== T1 || $[59] !== t10 || $[60] !== t21 || $[61] !== t7 || $[62] !== t8 || $[63] !== t9) {
    t22 = <T1 shouldFilter={t7} data-sentry-element={t8} data-sentry-source-file={t9}>{t10}{t21}</T1>;
    $[58] = T1;
    $[59] = t10;
    $[60] = t21;
    $[61] = t7;
    $[62] = t8;
    $[63] = t9;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== T2 || $[66] !== t11 || $[67] !== t12 || $[68] !== t13 || $[69] !== t14 || $[70] !== t22) {
    t23 = <T2 align={t11} className={t12} data-sentry-element={t13} data-sentry-source-file={t14}>{t22}</T2>;
    $[65] = T2;
    $[66] = t11;
    $[67] = t12;
    $[68] = t13;
    $[69] = t14;
    $[70] = t22;
    $[71] = t23;
  } else {
    t23 = $[71];
  }
  let t24;
  if ($[72] !== T3 || $[73] !== t15 || $[74] !== t16 || $[75] !== t17 || $[76] !== t18 || $[77] !== t19 || $[78] !== t20 || $[79] !== t23) {
    t24 = <T3 onOpenChange={t15} open={t16} data-sentry-element={t17} data-sentry-component={t18} data-sentry-source-file={t19}>{t20}{t23}</T3>;
    $[72] = T3;
    $[73] = t15;
    $[74] = t16;
    $[75] = t17;
    $[76] = t18;
    $[77] = t19;
    $[78] = t20;
    $[79] = t23;
    $[80] = t24;
  } else {
    t24 = $[80];
  }
  return t24;
};
function _temp() {
  return <span className="size-4 rounded bg-muted" />;
}
function _temp2() {
  return <span className="size-4 rounded bg-muted" />;
}